import { render, staticRenderFns } from "./SettingMessageTemplateEdit.vue?vue&type=template&id=5c64c82d"
import script from "./SettingMessageTemplateEdit.vue?vue&type=script&lang=js"
export * from "./SettingMessageTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports